import React from "react";
import { Helmet } from "react-helmet-async";
import { EventNames, trackEvent } from "../analytics";
import { canonicalUrl } from "../siteConfig";

export default function FreeSeoAuditPage() {
  const trackScanCta = (ctaId) => trackEvent(EventNames.CtaClicked, { cta_id: ctaId });
  const trackAssessmentCta = (source) => trackEvent(EventNames.AssessmentCtaClicked, { source });

  return (
    <div className="app page-grid">
      <Helmet>
        <title>Free SEO Scan | OptiSiteSEO</title>
        <meta
          name="description"
          content="Run a Free SEO Scan in under 60 seconds. Get technical SEO and visibility signals across discoverability, indexing, crawlability, performance, and measurement."
        />
        <link rel="canonical" href={canonicalUrl("/free-seo-audit")} />
      </Helmet>

      <section className="card section page-hero">
        <p className="eyebrow">Free SEO Scan</p>
        <h1>Find technical SEO and visibility issues with a Free SEO Scan</h1>
        <p className="subtext">
          No login for your first Free SEO Scan. Paste your URL and receive public technical SEO signals, discoverability blockers, and clear next
          steps before requesting a paid assessment.
        </p>
        <div className="cta-row">
          <a className="primary" href="/app/index.html" onClick={() => trackScanCta("free-seo-audit-primary-scan")}>
            Run Free SEO Scan
          </a>
          <a className="secondary" href="/demo/index.html">
            View sample report
          </a>
          <a className="secondary" href="/request-assessment" onClick={() => trackAssessmentCta("free_seo_audit")}>
            Request Assessment
          </a>
        </div>
      </section>

      <section className="card section page-card">
        <h2>What’s included</h2>
        <ul className="bullets">
          <li>Impact-prioritized issues (what to fix first)</li>
          <li>Indexability, metadata, and OG checks</li>
          <li>Performance, structured data, and measurement risk signals</li>
          <li>Plain-language notes for owners, operators, and implementers</li>
        </ul>
      </section>
    </div>
  );
}
